export interface IHistory {
    previous?: any,
    current?: any,
    query?: any,
}

export const setPreviousUrl = (urls: IHistory = {}) => ({
    type: 'SET_PREVIOUS_URL',
    history: urls,
});